// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"51":"5a4eebfb4a074072","102":"0370fdc1ccf6938c","224":"9df7ebe4fae93568","674":"c1c5cc2006ecd487","867":"f714a4395c58c025","917":"dca168d32d19ceeb"}[chunkId] + ".js";
};